<div class="row captcha">
  @if (isError) {
    <div class="col-12 captcha-error text-danger">
      {{ 'CAPTCHA_LOAD_ERROR' | translate }}
    </div>
  } @else {
    <div class="col-6 pr-2">
      <div class="form-control mb-0">
        <label for="captcha">{{ 'CAPTCHA_INPUT_LABEL' | translate }}</label>
        <input
          type="text"
          #inputEl
          id="captcha"
          [placeholder]="'CAPTCHA_INPUT_PLACEHOLDER' | translate"
          [disabled]="isLoading"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          [ngModel]="value"
          (ngModelChange)="updateValue($event)"
          maxlength="8"
          required
        />
      </div>
    </div>
    <div class="col-6 pl-2 captcha-col">
      <div class="captcha-container">
        @if (isLoading) {
          <div class="captcha-loader text-primary">
            <span
              class="spinner-border"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        }
        @if (!isLoading) {
          <img
            class="captcha-img"
            [src]="data.img"
            alt="CAPTCHA"
            (click)="inputEl.focus()"
          />
          <div
            class="captcha-reload"
            role="button"
            [title]="'CAPTCHA_RELOAD' | translate"
            (click)="reload(true)"
          >
            <fa-icon [icon]="faSync"></fa-icon>
          </div>
        }
      </div>
    </div>
  }
</div>
